import { render } from "./CpsOverviewItem.vue?vue&type=template&id=16d488e0&scoped=true&ts=true"
import script from "./CpsOverviewItem.vue?vue&type=script&lang=ts"
export * from "./CpsOverviewItem.vue?vue&type=script&lang=ts"

import "./CpsOverviewItem.vue?vue&type=style&index=0&id=16d488e0&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d488e0"]])

export default __exports__